export default "__VITE_ASSET__48155a8d__"